"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointName = exports.LocationIcon = exports.PinContent = exports.PinItself = exports.RadiusInput = exports.MapAutocompleteInput = exports.MapAutocompleteControls = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const components_common_inputs_1 = require("@hotelplan/components.common.inputs");
const components_common_map_pin_1 = require("@hotelplan/components.common.map-pin");
const components_common_select_input_1 = require("@hotelplan/components.common.select-input");
exports.MapAutocompleteControls = styled_components_1.default.div(({ theme }) => theme.mapRadiusSearch.autocompleteControls);
exports.MapAutocompleteInput = (0, styled_components_1.default)(components_common_inputs_1.BaseInput).attrs({
    hideLabel: true,
    className: 'map-autocomplete-input',
    icon: {
        name: 'location',
    },
})({});
exports.RadiusInput = (0, styled_components_1.default)(components_common_select_input_1.SelectInput)(({ theme }) => theme.mapRadiusSearch.radiusInput);
exports.PinItself = (0, styled_components_1.default)(components_common_map_pin_1.MapPin)(({ theme }) => theme.mapRadiusSearch.pin);
exports.PinContent = styled_components_1.default.div({
    display: 'flex',
    alignItems: 'center',
});
exports.LocationIcon = (0, styled_components_1.default)(components_common_icon_1.Icon).attrs(({ name }) => ({
    size: 'lg',
    name: name || `location`,
}))(({ theme }) => theme.mapRadiusSearch.locationIcon);
exports.PointName = styled_components_1.default.div({
    whiteSpace: 'nowrap',
});
//# sourceMappingURL=MapRadiusSearch.styled.js.map